import React, { Component } from 'react';
import TakePhotoModal from './TakePhotoModal';

class SelectFileOrTakePhoto extends Component {
  constructor(props) {
    super(props);
    this.takePhotoModal = null;
  }

  componentDidMount() {
    this.takePhotoModal = new window.bootstrap.Modal(window.$('#takePhotoModal'));
  }

  _onOpen = () => {
    document.getElementById('uploadDGREle').click();
  }

  _onTakePhotoFile = (imageData) => {
    const { onTakePhoto } = this.props;
    onTakePhoto(imageData, 'dgr');
    this.takePhotoModal.hide();
  }

  render() {
    const { onSelectImage } = this.props;
    return (
      <div
        className="modal fade theme-modal qty-modal"
        id="selectFileOrTakePhoto"
        tabIndex="-1"
        aria-labelledby="selectFileOrTakePhoto"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-sm">
          <div className="modal-content">
            <div className="modal-body">
              <h5 className="modal-title" id="selectFileOrTakePhoto">Select Type</h5>
              <p>Choose option for upload picture.</p>
            </div>
            <div className="modal-footer">
              <div className="row gx-2 button-wrap">
                <div className="col-5">
                  <button
                    type="button"
                    className="btn btn-link btn-left w-100"
                    onClick={() => {
                      this.takePhotoModal.show();
                    }}
                  >Take Photo
                  </button>
                </div>
                <div className="col-4">
                  <input id="uploadDGREle" accept="image/*" type="file" onChange={(e) => onSelectImage(e.target)} className="d-none" />
                  <button className="btn btn-link btn-left w-100" onClick={this._onOpen}>Browse</button>
                </div>
                <div className="col-3">
                  <button className="btn btn-link w-100 ps-0" data-bs-dismiss="modal">Cancel</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <TakePhotoModal onTakePhotoFile={this._onTakePhotoFile} />
      </div>
    );
  }
}

export default SelectFileOrTakePhoto;
